import { render } from "./Paginaiton.vue?vue&type=template&id=2474e77c&scoped=true"
import script from "./Paginaiton.vue?vue&type=script&lang=js"
export * from "./Paginaiton.vue?vue&type=script&lang=js"

import "./Paginaiton.vue?vue&type=style&index=0&id=2474e77c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-sakakibara\\Documents\\Git\\workflow-system\\workflow\\frontend\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2474e77c"]])

export default __exports__